import {UserActionTypes} from './global.types'

export const setFlightToken = (response) => (
    {
        type:UserActionTypes.SET_FLIGHT_TOKEN,
        flight_token:response
    }
)

export const setAirportList = (response) => (
    {
        type:UserActionTypes.SET_AIRPORT_LIST,
        airport_list:response
    }
)

export const setSearchFlights = (response) =>{ 
    const json_str = JSON.stringify(response)
    localStorage.setItem('SET_SEARCH_FLIGHTS',json_str)
    return (
    {
        type:UserActionTypes.SET_SEARCH_FLIGHTS,
        flights_list:response
    }
)
}

export const setCalenderFare = (response) =>{
    const json_str = JSON.stringify(response)
    localStorage.setItem('SET_CALENDER_FARE',json_str)
    
    return (

    {
        type:UserActionTypes.SET_CALENDER_FARE,
        calender_fare:response
    }
)
}

export const setSearchDataUser = (response) => (
    {
        type:UserActionTypes.SET_SEARCH_DATA,
        search_data:response
    }
)


export const setFilterData = (response) => (
    {
        type:UserActionTypes.SET_FILTER_DATA,
        search_filters:response
    }
)

export const setFareRule = (response) => (
    {
        type:UserActionTypes.SET_FARE_RULE,
        fare_rule:response
    }
)

export const setFareQuote = (response) => (
    {
        type:UserActionTypes.SET_FARE_QUOTE,
        fare_quote:response
    }
)

export const setBottomSticky = (response) => (
    {
        type:UserActionTypes.SET_BOTTOM_STICKY,
        showBottomSticky:response
    }
)

export const setBottomStickyData = (response) => (
    {
        type:UserActionTypes.SET_BOTTOM_STICKY_DATA,
        sticky_data:response
    }
)


export const setBottomStickyData2 = (response) => (
    {
        type:UserActionTypes.SET_BOTTOM_STICKY_DATA2,
        sticky_data2:response
    }
)

export const setUserId = (response) => (
    {
        type:UserActionTypes.SET_USER_ID,
        user_id:response
    }
)

export const setAirlines = (response) => (
    {
        type:UserActionTypes.SET_AIRLINES,
        airlines:response
    }
)


export const setPassengerata = (response) => (
    {
        type:UserActionTypes.SET_PASSENGER_DATA,
        passenger_data:response
    }
)

export const setRequestPassenger = (response) => (
    {
        type:UserActionTypes.SET_REQUEST_PASSENGER,
        request_passenger:response
    }
)



export const setPassengerIds = (response) => (
    {
        type:UserActionTypes.SET_PASSENGER_IDS,
        passenger_ids:response
    }
)
